export const modalIds = {
  confirm: 'confirm-modal',
};
